<template>
  <v-card
    flat
    tile
  >
    <v-container
      v-for="type in types"
      :key="type"
      class="grey lighten-4"
      fluid
    >
      <v-subheader>{{ type }}</v-subheader>

      <v-row>
        <v-col
          v-for="product in products"
          :key="product"
          cols="12"
          sm="6"
          md="4"
        >
          <v-card
            color="grey lighten-2"
            class="pa-2"
          >
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="headline justify-center">
                  {{ product.produto.name }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  <p class="text--primary">
                    Matrícula: <strong>{{ product.renach }}</strong>
                  </p>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-card
              v-for="(servico, ser ) in product.produto.servico"
              :key="ser"
              class="ma-2 mb-2 pa-2"
            >
              <v-card-text>
                <div>Serviço</div>
                <p class="display-1 text--primary">
                  {{ servico.nome }}
                </p>
                <p>Categoria: <strong>{{ servico.categoria }}</strong></p>
                <p>Quantidade Contratada: <strong>{{ servico.quantidade_contratado }}</strong></p>
                <p>Instrutor: <strong>{{ servico.instrutor.nome }}</strong></p>
                <p>LADV: <strong>{{ servico.ladv }}</strong></p>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  outlined
                  color="grey darken-3"
                  @click="()=>goCalendar(servico.instrutor, servico.id_servico)"
                >
                  Agendar Aula
                  <v-icon>mdi-arrow-right-thick</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
 import AlunoApi from './../../ws/aluno';
 import InstrutorApi from './../../ws/instrutor';
  export default {
    data: () => ({
      types: ['Matrículas Aluno'],
      products: [],
    }),
  async created(){
    try {
      const {data} = await AlunoApi.getProdutosMatriculas(this.$store.getters.getAluno.renach);
      this.products = data;
    } catch (error) {
      const { response } = error;
      alert(response.data.error);
    }
  },
  methods: {
    async goCalendar(instrutor, id_servico){
      try {
        const response = await InstrutorApi.getConfigSchedule(instrutor.cpf, id_servico);
        if(response.status === 200){
          this.$router.push(`/instrutor/${instrutor.cpf}/calendar/servico/${id_servico}`)
        }
      } catch (error) {
        const { response } = error;
        alert(response.data.error);
      }
    }
  },
  }
</script>
